<template>
  <Dialog v-bind="$attrs" v-on="$listeners" :width="width">
    <div class="preview">
      <div class="dialog-close close" @click="$emit('close')"></div>
      <img v-if="src" :src="src" alt="" />
    </div>
  </Dialog>
</template>

<script>
import Dialog from "./dlg.vue";
import { Px2rem } from "scripts/util";

export default {
  name: "PosterDialog",
  components: {
    Dialog,
  },
  props: {
    src: String,
  },
  data() {
    return {
      width: Px2rem(1200),
      show: false,
    };
  },
  watch: {},
  created() {
    console.log("visible", this.visible);
  },
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="less" scoped>
::v-deep {
  .dialog-content {
    background: none;
    box-shadow: none;

    &::before {
      content: none;
    }
  }
  .dialog-header {
    display: none;
  }
}
.preview {
  position: relative;
  margin: auto;
  width: 1200px;
  height: 675px;
  // background: url(~images/dialog/share.jpg) no-repeat 0 0;
  // background-size: 100% 100%;

  .close {
    top: -80px;
    right: 50%;
    width: 60px;
    height: 60px;
    padding: 14px;
    margin-right: -30px;
    background: #fffdec;
    border-radius: 50%;

    &::before {
      width: 100%;
      height: 100%;
    }
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.text {
  position: absolute;
  top: 55%;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 32px;
  color: var(--primary-color);

  span {
    display: inline-block;
    margin-left: 20px;
    font-size: 46px;
    vertical-align: baseline;
  }
}

.img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
